var _path, _path2, _rect, _g, _g2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g3, _line, _line2, _line3, _line4, _line5, _line6, _circle, _rect12, _rect13, _rect14, _rect15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOngoing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 159,
    viewBox: "0 0 196 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49805 113.607C6.883 113.607 6.38441 113.109 6.38441 112.494V101.596C6.38441 100.981 6.883 100.482 7.49805 100.482C8.11309 100.482 8.61168 100.981 8.61168 101.596V112.494C8.61168 113.109 8.11309 113.607 7.49805 113.607ZM2.04918 108.159C1.43414 108.159 0.935547 107.66 0.935547 107.045C0.935547 106.43 1.43414 105.931 2.04918 105.931H12.9469C13.562 105.931 14.0605 106.43 14.0605 107.045C14.0605 107.66 13.562 108.159 12.9469 108.159H2.04918Z",
    fill: "#EC8E58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.186 12.2205C192.67 12.5554 191.98 12.4087 191.646 11.8928L185.712 2.75231C185.377 2.23644 185.523 1.54675 186.039 1.21186C186.555 0.876958 187.245 1.02366 187.58 1.53954L193.514 10.68C193.849 11.1959 193.702 11.8856 193.186 12.2205ZM185.649 10.6172C185.133 10.9521 184.443 10.8054 184.108 10.2895C183.773 9.77366 183.92 9.08397 184.436 8.74908L193.577 2.81514C194.092 2.48025 194.782 2.62695 195.117 3.14282C195.452 3.65869 195.305 4.34838 194.789 4.68328L185.649 10.6172Z",
    fill: "#F4D1BC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 44,
    width: 116,
    height: 115,
    rx: 57.5,
    fill: "#FCE9DE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_5125_36186)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.5801,
    height: 58.5189,
    rx: 8,
    transform: "matrix(0.936915 -0.349557 0.350408 0.936597 51.1738 84.6211)",
    fill: "url(#paint0_linear_5125_36186)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 62.9062,
    y: 81.123,
    width: 58.4346,
    height: 58.3652
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_5125_36186_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_5125_36186)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.9062,
    y: 85.123,
    width: 50.4348,
    height: 50.365,
    rx: 8,
    fill: "white",
    fillOpacity: 0.31
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.3477,
    y: 90.7461,
    width: 39.1884,
    height: 39.1314,
    rx: 5,
    stroke: "white",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72.3477,
    y: 90.7461,
    width: 39.1884,
    height: 39.1314,
    rx: 5,
    stroke: "white",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 95,
    width: 32,
    height: 29,
    rx: 4,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 110,
    width: 29,
    height: 12,
    rx: 3,
    fill: "#FBEEE7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 98,
    width: 15,
    height: 2,
    rx: 1,
    fill: "#EDA479"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 102,
    width: 15,
    height: 2,
    rx: 1,
    fill: "#EDA479"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 118,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#EDA479"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 118,
    width: 5,
    height: 2,
    rx: 1,
    fill: "#EDA479"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 118,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#EDA479"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 97,
    width: 9,
    height: 8,
    rx: 2,
    fill: "#EDA479"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5125_36186)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 32,
    width: 58.3294,
    height: 37,
    rx: 5,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.25,
    y: 32.25,
    width: 57.8294,
    height: 36.5,
    rx: 4.75,
    stroke: "#EFEFEF",
    strokeWidth: 0.5
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 108.788,
    y1: 37.0938,
    x2: 153.188,
    y2: 37.0938,
    stroke: "#C6C6C7",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 108.788,
    y1: 41.8828,
    x2: 151.447,
    y2: 41.8828,
    stroke: "#C6C6C7",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 108.788,
    y1: 46.6699,
    x2: 144.917,
    y2: 46.6699,
    stroke: "#C6C6C7",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 112.271,
    y1: 55.877,
    x2: 141.871,
    y2: 55.877,
    stroke: "#C6C6C7",
    strokeOpacity: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 112.271,
    y1: 58.9238,
    x2: 141.871,
    y2: 58.9238,
    stroke: "#C6C6C7",
    strokeOpacity: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 112.271,
    y1: 61.9707,
    x2: 141.871,
    y2: 61.9707,
    stroke: "#C6C6C7",
    strokeOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 158.194,
    cy: 35.6996,
    r: 1.08824,
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 144.047,
    y: 61.1641,
    width: 13.0588,
    height: 3.91765,
    rx: 1.95882,
    fill: "#D9D9D9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 144.047,
    y: 55.5059,
    width: 3.91765,
    height: 3.91765,
    rx: 1.95882,
    fill: "#D9D9D9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 148.617,
    y: 55.5059,
    width: 3.91765,
    height: 3.91765,
    rx: 1.95882,
    fill: "#D9D9D9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 153.188,
    y: 55.5059,
    width: 3.91765,
    height: 3.91765,
    rx: 1.95882,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_5125_36186",
    x: 37.4678,
    y: 54.4336,
    width: 102.802,
    height: 102.707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5125_36186"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5125_36186",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5125_36186"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.47 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_5125_36186",
    result: "effect3_innerShadow_5125_36186"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_5125_36186",
    x: 62.9062,
    y: 81.123,
    width: 58.4346,
    height: 58.3652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5125_36186"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_5125_36186",
    result: "effect2_innerShadow_5125_36186"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5125_36186_clip_path",
    transform: "translate(-62.9062 -81.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.9062,
    y: 85.123,
    width: 50.4348,
    height: 50.365,
    rx: 8
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5125_36186",
    x: 96,
    y: 27,
    width: 74.3291,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5125_36186"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5125_36186",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5125_36186",
    x1: 29.2901,
    y1: 0,
    x2: 29.2901,
    y2: 58.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1935C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9631F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOngoing);
export default __webpack_public_path__ + "static/media/ongoing.767b9ad866e9a9950154bca4c315d6d6.svg";
export { ForwardRef as ReactComponent };